import { Product } from 'shared-types'
import { GTMEvent, NotifyBackInStockDTO } from '~/lib'
import { formatPriceForDataLayer } from '~/lib/gtm/helpers'

export const adaptNotifyBackInStock = ({
  product,
}: {
  product: Product
}): NotifyBackInStockDTO => {
  return {
    event: GTMEvent.NOTIFY_BACK_IN_STOCK,
    ecommerce: {
      currency: product?.finalPrice?.currencyCode,
      items: [
        {
          item_id: product?.sku,
          item_name: product?.title,
          price: Number(
            formatPriceForDataLayer(product?.finalPrice?.centAmount)
          ),
          item_brand: product?.brandName,
          item_category: product?.category1Name,
          item_category2: product?.category2Name,
          item_category3: product?.category3Name,
          item_category4: product?.category4Name,
          item_category5: product?.category5Name,
          in_stock: product?.inStock ? 'Yes' : 'No',
          quantity: 1,
          item_list_id: product?.listId,
          item_list_name: product?.listName,
          item_status_tags: product?.item_status_tags,
        },
      ],
    },
  }
}
